import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
  Dropdown,
  Heading,
  OptionType,
} from '@chargify/custom-ui-components';

import { Wrapper } from './PaymentsProfilesHeader.styles';

type Props = {
  dropdownOptions: OptionType[];
  onDropdownSelection: (option: OptionType) => void;
};

export const PaymentsProfilesHeader = ({
  dropdownOptions,
  onDropdownSelection,
}: Props) => {
  const { t } = useTranslation('subscriptions-manager');
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const ref = React.useRef<HTMLDivElement>(null);

  return (
    <Wrapper>
      <Heading variant={'h3'}>{t('payment_profile.payment_methods')}</Heading>
      {dropdownOptions.length > 0 && (
        <Dropdown
          isOpen={isDropdownOpen}
          options={dropdownOptions}
          onOptionSelect={(e) => {
            onDropdownSelection(e);
            setIsDropdownOpen(false);
          }}
          onClose={() => setIsDropdownOpen(false)}
          maxWidth={ref.current?.getBoundingClientRect().width}
        >
          <div ref={ref}>
            <Button
              iconLeft={'chevronDown'}
              label={t('payment_profile.new_payment_method')}
              onClick={() => setIsDropdownOpen(true)}
            />
          </div>
        </Dropdown>
      )}
    </Wrapper>
  );
};
